import BaseAddressesController from "../base_addresses_controller";

// Connects to data-controller="mini-app--addresses"
export default class extends BaseAddressesController {
  BRANCH_LOAD_CLASSES = {
    low: "bg-mini-app-green-500",
    medium: "bg-mini-app-orange-500",
    high: "bg-mini-app-red-500",
  };

  placemarkCallback(selectedBranch) {
    Turbo.visit(`/mini_app/branches/${selectedBranch.id}`);
  }

  buildPlacemarkHTML(branch) {
    const parser = new DOMParser();
    const placemarkElement = parser.parseFromString(
      `
      <div class="-translate-x-2/4 -translate-y-14 cursor-pointer">
        <img src="${this.PLACEMARK_URL}" class="mx-auto mb-0.5 size-14">
        <div class="flex w-max items-center gap-x-1 rounded-2xl bg-white p-1 pr-2">
          <div class="size-4 rounded-full ${this.BRANCH_LOAD_CLASSES[branch.load]}"></div>
          <div class="text-2xs font-semibold">${branch.data.site}</div>
        </div>
      </div>
    `,
      "text/html",
    ).body.childNodes[0];
    return placemarkElement;
  }
}
